function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "night-cloudy-fog");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "24.4644699%",
  y1: "72.8710355%",
  x2: "63.7305027%",
  y2: "39.9796208%",
  id: "linearGradient-1"
}, React.createElement("stop", {
  stopColor: "#F2F2F2",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#CFCFCF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "72.5161778%",
  y1: "64.9090909%",
  x2: "8.62380839%",
  y2: "22.6545455%",
  id: "linearGradient-2"
}, React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "2%"
}), React.createElement("stop", {
  stopColor: "#FFFFFF",
  stopOpacity: 0,
  offset: "100%"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "night-cloudy-fog",
  transform: "translate(0.000000, 1.000000)"
}, React.createElement("path", {
  d: "M109.998732,46.5018686 C99.5211827,45.6537104 89.9953571,40.089702 84.1041444,31.3769113 C78.2129317,22.6641207 76.5938107,11.7453451 79.7027967,1.69578931 C79.8627025,1.11855258 79.6637666,0.501466747 79.1969238,0.126605884 C78.730081,-0.248254979 78.0850295,-0.308865982 77.5566267,-0.0275214274 C64.831216,7.19280522 58.0098378,21.6353921 60.5123312,36.059573 C63.0148247,50.4837539 74.3016468,61.7796452 88.7142469,64.2841494 C103.126847,66.7886536 117.557838,59.9617944 124.772368,47.2261586 C125.104961,46.6936286 125.070491,46.0100362 124.686017,45.5137227 C124.301544,45.0174093 123.648633,44.8136671 123.050441,45.0033375 C118.834836,46.3297131 114.404949,46.8383302 109.998732,46.5018686 L109.998732,46.5018686 Z",
  id: "Path",
  fill: "#EFCC00",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M43.7846986,34.7968923 C59.965981,34.7918382 74.8214334,43.7088109 82.3800995,57.9637511 C94.8680469,50.6894829 110.593908,52.0019061 121.693246,61.2446835 C132.792585,70.4874608 136.879845,85.6740626 131.911005,99.2097343 C126.942165,112.745406 113.985167,121.720956 99.5197508,121.647749 L43.6599558,121.796892 C19.5472281,121.796892 0,102.321279 0,78.2968923 C0,54.2725074 19.5472281,34.7968923 43.6599558,34.7968923 L43.7846986,34.7968923 Z",
  id: "Path",
  fill: "url(#linearGradient-1)",
  fillRule: "nonzero"
}), React.createElement("ellipse", {
  id: "Oval",
  fill: "url(#linearGradient-2)",
  fillRule: "nonzero",
  transform: "translate(99.782296, 87.183986) rotate(-74.390000) translate(-99.782296, -87.183986) ",
  cx: 99.7822963,
  cy: 87.1839858,
  rx: 34.1705349,
  ry: 34.2478481
}), React.createElement("path", {
  d: "M80,130.796892 L105,130.796892",
  id: "Path",
  stroke: "#A5A9AA",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M25,130.796892 L67,130.796892",
  id: "Path",
  stroke: "#B9C1C6",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M68,142.796892 L96,142.796892",
  id: "Path",
  stroke: "#A5A9AA",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M35,142.796892 L54,142.796892",
  id: "Path",
  stroke: "#A5A9AA",
  strokeWidth: 3,
  strokeLinecap: "round"
})));

var SvgNightCloudyFog = function SvgNightCloudyFog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "135px",
    height: "146px",
    viewBox: "0 0 135 146",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNightCloudyFog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/night-cloudy-fog.ecb14f52.svg";
export { ForwardRef as ReactComponent };